import { render, staticRenderFns } from "./EventBanners.vue?vue&type=template&id=38381cb9&"
import script from "./EventBanners.vue?vue&type=script&lang=js&"
export * from "./EventBanners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports